import React, { useEffect, useRef, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { ORG_LABELS } from '../config';
import { initials } from '../hooks';
import { Button } from '../ui/basics';
import { Icon } from '../ui/icons';

const NAV = [
  { page: 'recruitment', to: '/recruitment', label: 'Recruitment', icon: 'chart' },
  { page: 'placements', to: '/placements', label: 'Placements', icon: 'briefcase' },
  { page: 'reports', to: '/reports', label: 'Reports', icon: 'file' },
  { page: 'analytics', to: '/analytics', label: 'Analytics', icon: 'pulse' },
  { page: 'directory', to: '/directory', label: 'Clients & Recruiters', icon: 'book' },
  { page: 'onboardings', to: '/onboardings', label: 'Onboardings', icon: 'clipboard' },
  { page: 'users', to: '/users', label: 'Users & Access', icon: 'users' },
];

function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div className="user-menu" ref={ref}>
      <button className="trigger" onClick={() => setOpen(!open)} aria-haspopup="menu" aria-expanded={open}>
        <span className="avatar">{initials(user.display_name || user.email)}</span>
        <span className="who">{user.display_name || user.email}<small>{user.role || 'Custom access'}</small></span>
      </button>
      {open && (
        <div className="dropdown" role="menu">
          <div className="head">{user.email}</div>
          <button role="menuitem" onClick={() => { setOpen(false); navigate('/change-password'); }}>Change password</button>
          <hr />
          <button role="menuitem" className="danger" onClick={logout}>Sign out</button>
        </div>
      )}
    </div>
  );
}

export default function AppShell() {
  const { user, orgs, org, setOrg, hasPage } = useAuth();
  const [navOpen, setNavOpen] = useState(false);
  const { pathname } = useLocation();
  const showOrgs = orgs.length > 1 && pathname !== '/users';

  useEffect(() => { document.documentElement.dataset.org = org; }, [org]);
  useEffect(() => setNavOpen(false), [pathname]);

  return (
    <div className={`shell ${navOpen ? 'nav-open' : ''}`}>
      <aside className="sidebar">
        <div className="brand"><img src="/VivyaLogo.png" alt="" /><div>VivyaHire Finance<small>Operations</small></div></div>
        <nav aria-label="Main">
          <span className="nav-label">Workspace</span>
          {NAV.filter((n) => hasPage(n.page)).map((n) => (
            <NavLink key={n.to} to={n.to} className="nav-link"><Icon name={n.icon} />{n.label}</NavLink>
          ))}
        </nav>
        <div className="sidebar-foot">Signed in as<br /><b>{user.email}</b></div>
      </aside>
      <div className="scrim" onClick={() => setNavOpen(false)} />
      <div className="main">
        <header className="topbar">
          <Button className="burger" variant="ghost" icon="menu" aria-label="Open menu" onClick={() => setNavOpen(true)} />
          {showOrgs ? (
            <label className="org-select">
              <span className="dot" />
              <span className="sr-only">Organization</span>
              <select value={org} onChange={(e) => setOrg(e.target.value)} aria-label="Organization">
                {orgs.map((o) => <option key={o} value={o}>{o === 'combined' ? 'Combined (All Teams)' : ORG_LABELS[o]}</option>)}
              </select>
            </label>
          ) : <strong>{pathname === '/users' ? 'Users & Access' : ORG_LABELS[org]}</strong>}
          <UserMenu />
        </header>
        <main className="content"><Outlet /></main>
      </div>
    </div>
  );
}
